const { sha3_512 } = require('js-sha3');

/* eslint-disable max-len */
export default {
    name: 'NewPassword',
    data() {
        return {
            dataForm: {
                password: '',
                password_confirm: null
            },
            invalidPasswordReason: undefined,
            isLoading: false,
            isPasswordVisible: false,
            isPasswordConfirmVisible: false
        };
    },
    computed: {
        isPasswordInvalid() {
            if (!this.dataForm.password || !this.dataForm.password_confirm) {
                return true;
            }
            if (this.dataForm.password !== this.dataForm.password_confirm) {
                this.invalidPasswordReason = 'Las contraseñas no coinciden';
                return true;
            }
            // (?=.*[a-z]) One or more lowercase alphabetical character
            // (?=.*[A-Z]) One or more uppercase alphabetical character
            // (?=.*[0-9]) One or more numeric character
            // (?=.{6,}) At least 6 characters
            const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})');
            if (!this.dataForm.password.match(passwordRegex)) {
                this.invalidPasswordReason = 'La contraseña debe contener al menos 6 caracteres incluyendo una mayúscula, una minúscula y un número.';
                return true;
            }
            this.invalidPasswordReason = undefined;
            return false;
        }
    },
    methods: {
        onSubmit() {
            this.isLoading = true;
            const body = {
                password: sha3_512(this.dataForm.password),
                user_uuid: this.$route.query.user_uuid,
                recovery_token: this.$route.query.recovery_token,
                is_backoffice: true
            };
            this.$usersService.passwordChange(body).then(() => {
                this.$bvToast.toast(`Su contraseña ha sido actualizada correctamente.`, {
                    title: `Credenciales actualizadas`,
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                    variant: 'success'
                });
            })
                .catch(() => {
                    this.$bvToast.toast(
                        `Parece que su solicitud de cambio de contraseña ha expirado o ya ha sido utilizada. Por favor, solicitela de nuevo`,
                        {
                            title: `Error: Solicitud expirada`,
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 10000,
                            variant: 'danger'
                        });
                })
                .finally(() => this.isLoading = false);
        }
    }
};
